import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';

import {
  newbuildingInfoReducer,
  answersReducer,
  filtersReducer,
  reviewsReducer,
  userReducer,
  questionsReducer,
  lkTypeReducer,
} from '../../reducers';
import { IApplicationState, IThunkContext, TReduxActions, TReduxStore } from '../../types/redux';
import { newReviewReducer } from '../../reducers/newReview';
import { newAnswerReducer } from '../../reducers/newAnswer';
import { newQuestionReducer } from '../../reducers/newQuestion';
import { sortReducer } from '../../reducers/sort';
import { tabsReducer } from '../../reducers/tabs';

let storeReminder: TReduxStore;

interface IThunkExt {
  dispatch: ThunkDispatch<IApplicationState, IThunkContext, TReduxActions>;
}

/**
 * Хелпер для создания Redux стора
 */
export function createReduxStore(initialState: IApplicationState, debugEnabled: boolean, context: IThunkContext) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    newbuildingInfo: newbuildingInfoReducer,
    filters: filtersReducer,
    sort: sortReducer,
    newReview: newReviewReducer,
    newAnswer: newAnswerReducer,
    reviews: reviewsReducer,
    questions: questionsReducer,
    answers: answersReducer,
    user: userReducer,
    lkType: lkTypeReducer,
    newQuestion: newQuestionReducer,
    tabs: tabsReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context)));

  const createStore = (): TReduxStore =>
    _createStore<IApplicationState, TReduxActions, IThunkExt, {}>(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
